// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__0IfNO","menu-item":"nav_menu-item__tyVqe","bottom":"nav_bottom__I4Pm1"};